export const styles = {
  content: 'bg-neutral50 p-sm px-md rounded-md max-w-[25.2rem]',
  text: 'text-center',
};
